// extracted by mini-css-extract-plugin
export var legendIndicator = "_d4-1";
export var legendRight = "_d4-0";